module.exports = __webpack_public_path__ + "static/img/chuandaihudie.9538a21.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/productBanner/woman/banner/chuandaihudie.jpg
// module id = qH2c
// module chunks = 0